package lacaravana.app

import kotlinx.browser.document
import kotlinx.coroutines.MainScope
import kotlinx.coroutines.launch
import lacaravana.ui.CajaView
import lacaravana.ui.CartaView
import lacaravana.ui.CocinaView
import lacaravana.ui.MenuAdminView
import lacaravana.ui.MesasView
import lacaravana.ui.PedidoView
import lacaravana.sync.NatsSync
import lacaravana.ui.Router
import lacaravana.ui.StockView

val appScope = MainScope()

fun main() {
    appScope.launch {
        val db = Database.open()
        document.getElementById("status")?.textContent = "DB ready — site: ${db.siteId()}"

        Router.register("mesas", "Mesas") { MesasView.render(it) }
        Router.register("menu", "Menu") { MenuAdminView.render(it) }
        Router.register("cocina", "Cocina") { CocinaView.render(it) }
        Router.register("caja", "Caja") { CajaView.render(it) }
        Router.register("stock", "Stock") { StockView.render(it) }
        Router.register("pedido", "") {
            val mesaId = Router.currentParam?.toIntOrNull() ?: 0
            PedidoView.currentMesaId = mesaId
            PedidoView.render(it)
        }
        Router.register("carta", "") { CartaView.render(it) }
        Router.start(db)
        val natsUrl = js("new URLSearchParams(window.location.search).get('nats')") as? String
        try { NatsSync.start(db, natsUrl) } catch (_: dynamic) {}
    }
}

private fun renderPlaceholder(name: String) {
    val content = document.getElementById("content") ?: return
    content.innerHTML = "<h2>$name</h2><p>Coming soon</p>"
}
